export default "__VITE_ASSET__DHejfQsM__"